import {
  messageFromAuthJson,
  parseVerifyOtpResult,
  postAuthGetOtp,
  postAuthVerifyOtp,
} from "@/lib/authApi";
import type { AuthUser } from "@/lib/authSession";

export async function requestGetOtp(
  mobileNumber: string,
  languageCode: "en" | "ar"
): Promise<{ ok: boolean; message: string }> {
  const { ok, json } = await postAuthGetOtp({
    mobileNumber,
    language_code: languageCode,
  });
  return {
    ok,
    message: ok
      ? (typeof json.message === "string" ? json.message : "OK")
      : messageFromAuthJson(json),
  };
}

export async function requestVerifyOtp(
  mobileNumber: string,
  otp: string
): Promise<
  | { ok: true; message: string; user: AuthUser }
  | { ok: false; message: string }
> {
  const { ok, json } = await postAuthVerifyOtp({ mobileNumber, otp });
  if (!ok) {
    return {
      ok: false,
      message: messageFromAuthJson(json),
    };
  }

  const parsed = parseVerifyOtpResult(json);
  const user: AuthUser = {
    phone: mobileNumber,
    ...(parsed.customerId ? { customerId: parsed.customerId } : {}),
    ...(parsed.tenantId ? { tenantId: parsed.tenantId } : {}),
    ...(parsed.businessUnitId ? { businessUnitId: parsed.businessUnitId } : {}),
    ...(parsed.qrCodeUrl ? { qrCodeUrl: parsed.qrCodeUrl } : {}),
    ...(parsed.name ? { name: parsed.name } : {}),
    ...(parsed.email ? { email: parsed.email } : {}),
  };

  return {
    ok: true,
    message:
      typeof json.message === "string" && json.message.trim()
        ? json.message.trim()
        : "Signed in",
    user,
  };
}
